import { SortResult } from "../../components/rank-sort/types";
import { RESPONSE_TYPE } from "../../const/vote";
import { IQuestionState } from "../../domain/ballot-state";
import { ApiIQuestion } from "../../domain/election";
import { QuestionValidationResult, VoteFieldValidation } from "../types";

export type PreferenceVote = { [candidate_id: string]: SortResult<string> };

const getValueFromConfig = (config: any | undefined, field: string, cast?: "number") => {
    if (!config) {
        return null;
    }
    if (config[field] === null || config[field] === null || config[field] === "") {
        return null;
    }
    switch (cast) {
        case "number":
            return Number(config[field]);
    }
    return config[field];
}

export class PREFERENCE {
    static TYPE = RESPONSE_TYPE.PREFERENCE;
    static VERSION = "1.0.0";
    static INITIAL_VALUE: PreferenceVote = {
    }
    static normalize = (questionState?: IQuestionState<PreferenceVote>): PreferenceVote => {
        if (!questionState) {
            return PREFERENCE.INITIAL_VALUE;
        }
        const { response_type, data_version, value } = questionState;
        if (response_type !== PREFERENCE.TYPE) {
            return PREFERENCE.INITIAL_VALUE
        }
        if (data_version !== PREFERENCE.VERSION) {
            return PREFERENCE.INITIAL_VALUE;
        }
        if (!value) {
            return PREFERENCE.INITIAL_VALUE
        }
        const newVal: any = {};
        let modified = false;
        for (const vote of Object.values(value)) {
            if (typeof vote === 'object' && typeof vote.id === 'string') {
                newVal[vote.id] = vote;
            } else {
                modified = true;
            }
        }
        if (!modified) {
            return value;
        } else {
            return newVal;
        }
    };
    static validate = (ballot: ApiIQuestion, vote: PreferenceVote): QuestionValidationResult => {
        const { required, voting_config } = ballot;
        if (required) {
            const selected = Object.values(vote).filter(c => c.index !== null)
            if (selected.length === 0) {
                return { valid: false, empty: true }
            }
        }
        const reasons: Array<VoteFieldValidation> = [];
        const totalVotes = Object.values(vote).filter(v => v.index !== null).length;
        const candidates = totalVotes + 1;

        const min_select: number | null = getValueFromConfig(voting_config, 'min_select', 'number')

        const max_select: number | null = getValueFromConfig(voting_config, 'max_select', 'number')


        if (min_select && totalVotes < min_select) {
            reasons.push({
                reason: "not_enough_candidates",
                meta: { expected: min_select, found: candidates }
            });
        }
        if (max_select && totalVotes > max_select) {
            reasons.push({
                reason: "too_many_candidates",
                meta: { expected: max_select, found: candidates },
            });
        }

        const vals = Object.values(vote);
        for (const val of vals) {
            if (val && val.index !== null) {
                const dups = vals.filter((v) => v.index === val.index && v.id !== val.id)
                if (dups.length > 1) {
                    reasons.push({
                        reason: "duplicate",
                        target: `candidate_${val.id}`,
                        meta: {
                            expected: null,
                            found: dups
                        }
                    })
                }
            }
        }

        return {
            valid: reasons.length === 0,
            empty: false,
            reasons,
        };
    };

    static prepareSubmit = (ballot: ApiIQuestion, questionState: IQuestionState<PreferenceVote>): any => {
        const value = PREFERENCE.normalize(questionState);
        const votes = Object.values(value).filter(v => v.index !== null).sort(sortPreferences);
        for (let i = 0; i < votes.length; i++) {
            value[votes[i].id].index = i + 1;
        }
        return value;
    };

}



export const sortPreferences = (a: SortResult, b: SortResult) => {
    if (a.index === null)
        return 1;
    if (b.index === null)
        return -1;
    return a.index > b.index ? 1 : -1
}
